import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import EditHighlightLayer from "../components/EditPromotionLayer";
 
 
const EditHighlightPage = () => {
  return (
    <>
   
 
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Edit Promotion  </h5><Breadcrumb title="Edit Promotion" /></div>
 
        {/* CalendarMainLayer */}
        <EditHighlightLayer />
 
 
    </>
  );
};
 
export default EditHighlightPage;
 
 